import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { panelTextInput } from '@atlaskit/editor-common/ui';
export var Input = function Input(props) {
  var defaultValue = props.defaultValue,
    onBlur = props.onBlur,
    onSubmit = props.onSubmit,
    placeholder = props.placeholder;
  var _useState = useState(defaultValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var handleChange = function handleChange(e) {
    setText(e.target.value);
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    onSubmit && onSubmit(text);
  };
  var handleBlur = function handleBlur(e) {
    e.preventDefault();
    onBlur && onBlur(text);
  };
  return jsx("form", {
    onSubmit: handleSubmit
  }, jsx("input", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: panelTextInput,
    value: text,
    onChange: handleChange,
    placeholder: placeholder,
    onBlur: handleBlur
  }));
};